import { z } from "zod";

export const movementSchema = z.object({
  amount: z.string()
    .trim()
    .regex(/^\d+(?:\.\d{1,3})?$/, "Use a positive amount with up to three decimal places.")
    .refine((value) => Number(value) > 0, "The amount must be greater than zero."),
  description: z.string().trim().min(1, "Add a short description.").max(200),
  effectiveAt: z.string().min(1, "Choose when this happened."),
  accountId: z.string().min(1, "Choose an account."),
  destinationAccountId: z.string(),
  categoryId: z.string(),
  fee: z.string().trim().refine(
    (value) => value === "" || /^\d+(?:\.\d{1,3})?$/.test(value),
    "Use a non-negative fee amount.",
  ),
});

export type MovementForm = z.infer<typeof movementSchema>;
